import css from './containerInfo.module.scss';

import cx from 'classnames';
import { memo } from 'react';

import { TContainerInfo } from './interface';

type TProps = {
  info: TContainerInfo;
};

export default memo(function ContainerInfo({ info }: TProps) {
  return (
    <div className={css.root}>
      <h2 className={cx(css.title, info.pending && css.titlePending)}>
        {info.title}
      </h2>
      <div className={css.meta}>
        {info.itemsLabel}
        {': '}
        <span className={css.metaCount}>{info.total}</span>
        {info.pending > 0 && (
          <span className={css.metaPending}>
            {' +'}
            {info.pending}
          </span>
        )}
      </div>
    </div>
  );
});
